<template>
  <div id="digital-flop">
    <module-title title="今日多渠道销售环图占比" />
    <div id="todayChart" style="width: 100%; height: 80%;"></div>

  </div>
</template>

<script>
import moduleTitle from '@/components/Common/ModuleTitle.vue';


export default {
  name: 'TodaySale',
  components: {
    moduleTitle
  },
  data() {
    return {
      charts: null,
      options: {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            name: '支付方式占比',
            type: 'pie',
            radius: ['30%', '80%'],
            avoidLabelOverlap: false,
            // startAngle:180,
            label: {
              show: true,
              // 设置标签的样式
              rich: {
                name: {
                  fontSize: 11,
                  color: '#ccc'

                },
                value: {
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: 'white'

                },
                percent: {
                  fontSize: 11,
                  color: '#ccc'

                }
              },
              // 使用 rich 中的样式
              formatter: function (params) {
                // const percentColor = params.name === '线上' ? '#0088F0' : '#14D85D';
                // return `{name|${params.name}}\n{value|数值: ${params.value}}\n{percent|百分比: ${params.percent}%|color:${percentColor}}`;
                return `{name|${params.name}}\n{value|${params.value}}\n{percent|环比昨日: ${params.percent}%}`;

              },
              // alignTo: 'edge',
              // position: function (params) {

              //   return params.value > 0 ? 'right' : 'left';
              // },
              // 修改 position 配置
              // position: 'outer',
              // alignTo: 'edge',
              // distanceToLabelLine: 5,

            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },

            labelLine: {
              show: true,
              length: 20, // 调整标签线第一段长度
              length2: 20 // 调整标签线第二段长度
            },
            data: [
              {
                value: 36, name: '线下', itemStyle: {
                  color: '#14D85D'
                }
              },

              {
                value: 64, name: '线上', itemStyle: {
                  color: '#0088F0'
                }
              },

            ],

          }
        ]
      }
    }
  },
  methods: {
    setData(val) {
      if (val == null) return;
      if (val.Current) {
        let channelData = val.Current[0];
        this.options.series[0].startAngle = 180-parseInt(channelData.OnLinePersent * 100);
        this.options.series[0].data = [
          {
            value: channelData.OffLineAmt, persent: channelData.OffLinePersent * 100, name: '线下', itemStyle: {
              color: '#14D85D'
            }
          },

          {
            value: channelData.OnLineAmt, persent: channelData.OnLinePersent * 100, name: '线上', itemStyle: {
              color: '#0088F0'
            }
          },

        ];//val;
        this.chart.setOption(this.options);
      }
    }
  },
  mounted() {
    // 初始化 ECharts 实例
    this.chart = this.$echarts.init(document.getElementById('todayChart')); // 如果你选择了全局引入

    // 使用配置项和数据显示图表
    this.chart.setOption(this.options);
  }
}
</script>

<style lang="less" scoped>
#digital-flop {
  width: 100%;
  height: 100%;
  background: rgba(24, 50, 148, 0.30);
  border: 1px solid;
  border-image: linear-gradient(156deg, rgba(255, 255, 255, 0.30) 8%, rgba(255, 255, 255, 0.00) 91%) 1 1;
  border-radius: 8px;

}
</style>
